import React, { useState } from "react";
import { TabSelector } from "components";
import { MaterialTabSelector } from "components";
import { FormContainer, H1 } from "appStyles";
import { withRedux } from "helpers";
import App from "./App";
import Rewards from "./Rewards";
import Deals from "./Deals";
import PunchCards from "./PunchCards";
import Store from "./Orders/Store";

function Analytics(props) {
  // console.log("loading id at analytics");
  // console.log(props.activeApp.id);
  const appId = props.activeApp.id;
  const userId = props.userId;
  const activeApp = props.activeApp;
  const shippoToken = props.activeApp;
  console.log(shippoToken);
  let detailsSubmitted = null;
  let requiresMoreInfo = null;
  if (activeApp.stripeExpressAccountInfo) {
    const {
      stripeExpressAccountInfo: {
        stripeExpressDetailsSubmitted,
        stripeExpressRequiresMoreInfo,
      },
    } = activeApp;
    detailsSubmitted = stripeExpressDetailsSubmitted;
    requiresMoreInfo = stripeExpressRequiresMoreInfo;
  }

  // const {
  //   stripeExpressAccountInfo: {
  //     stripeExpressDetailsSubmitted,
  //     stripeExpressRequiresMoreInfo,
  //   },
  // } = props.activeApp;

  const loadOrders = () => {
    props.history.push(`/orders`, {
      appId,
      userId,
      stripeExpressDetailsSubmitted: detailsSubmitted,
      stripeExpressRequiresMoreInfo: requiresMoreInfo,
      shippoToken,
    });
  };
  const [currentTab, setCurrentTab] = useState("app");
  const tabs = [
    {
      text: "App",
      value: "app",
      tabComponent: <App {...props} />,
    },
    {
      text: "Rewards",
      value: "rewards",
      tabComponent: () => <Rewards {...props} />,
    },
    {
      text: "Deals",
      value: "deals",
      tabComponent: <Deals {...props} />,
    },
    {
      text: "Punchcards",
      value: "punchCards",
      tabComponent: <PunchCards {...props} />,
    },
    {
      text: "Purchases",
      value: "store",
      tabComponent: () => loadOrders(props.activeApp.id),
    },
  ];

  const TabComponents = {
    app: <App {...props} />,
    rewards: <Rewards {...props} />,
    deals: <Deals {...props} />,
    punchCards: <PunchCards {...props} />,
    // store: <Store {...props} />,
  };

  return (
    <FormContainer width="90%" top="2%" left="7%">
      <H1 margin="0px 0px 10px 56px">Analytics</H1>
      {/* <TabSelector
        tabs={tabs}
        current={currentTab}
        style={{
          marginLeft: "55px",
        }}
      />

      <div
        style={{
          marginLeft: "35px",
        }}
      >
        {TabComponents[currentTab]}
      </div> */}
      <MaterialTabSelector tabs={tabs} hideTabs={false} />
    </FormContainer>
  );
}

export default withRedux(Analytics);
